"use client";

import { Card } from "@kyan/ui";

import { Divider } from "#/components/Divider/Divider";

import { ReferralLinks } from "./components/ReferralLinks/ReferralLinks";
import { ReferralStats } from "./components/ReferralStats/ReferralStats";

export const ReferralPanel = () => {
  return (
    <Card className="flex-col rounded-2xl p-0">
      <ReferralLinks />
      <Divider />
      <ReferralStats />
    </Card>
  );
};
